import React, {Component} from 'react';
import $ from 'jquery';
import {Link} from 'react-router-dom';
import contracts from '../../../data/contracts.json';

class RealEstate extends Component {

    componentDidMount(){
        $('html, body').animate({scrollTop: 0}, 300);
    }

    render(){
        return(
            <div className="page page-inner pb-5">
                <div className="container-fluid">
                    <div className="container p-0">
                        <h1 className="page-title">Viewing Real Estate Documents</h1>
                        <div className="page-content">
                            {
                                contracts.contracts[0].category["Real Estate"].map((contract, i)=>{
                                    return(
                                        <div className="mb-5" key={i}>
                                            <h4><Link to={contract.url}>{contract.name}</Link></h4>
                                            <p>
                                                {contract.description}
                                            </p>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RealEstate;


// WEBPACK FOOTER //
// ./src/pages/contracts/real-estate/RealEstate.js